export var LoginFlow;
(function (LoginFlow) {
    LoginFlow["SIWE"] = "siwe";
    LoginFlow["SIWE_WALLETCONNECT"] = "siwe_walletconnect";
    LoginFlow["MICROSOFT"] = "microsoft";
    LoginFlow["GOOGLE"] = "google";
    LoginFlow["FACEBOOK"] = "facebook";
})(LoginFlow || (LoginFlow = {}));
export class AuthError extends Error {
    constructor(message, code, status) {
        super(message);
        this.code = code;
        this.status = status;
        this.name = 'AuthError';
    }
}
